import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import apiService from "../../service/apiService";
import { Form, Card, CardHeader, Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import Header from "../../components/Header";
import { set } from "lodash";

const EditUser = () => {
  const { userId } = useParams();
  const [userRoleId, setUserRoleId] = useState(0);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const [gendid, setGendId] = useState(0);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPHone] = useState("");
  const [age, setAge] = useState(0);
  const [genders, setGenders] = useState([]);
  const [aadhaarNumber, setAadhaarNumber] = useState('');

  const [blocks, setBlocks] = useState([]);
  const [block, setBlock] = useState(0);
  const [pgs, setPgs] = useState([]);
  const [selectedPgs, setSelectedPgs] = useState([]);
  const [rolename, setRoleName] = useState("");
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [pgsByBlock, setPgsByBlock] = useState({});
  const [dists, setAllDists] = useState([]);
  const [dist, setDist] = useState(0);
  const [districtId, setDistrictId] = useState(0);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [district, setDistrict] = useState('');

  const fetchRoleId = async () => {
    try {
      const response = await apiService.get('/user-roles/get-all');
      setRoles(response.data);
    } catch (error) {
      console.error('Error fetching seeds:', error);
    }
  };
  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
    } catch (error) {
      console.error('Error fetching seeds:', error);
    }
  };

  // fetch blocks by district
  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      setBlocks(response.data.body.blocks);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  // fetch PGs by blockId
  const fetchPgsByBlock = async (blockId) => {
    try {
      const response = await apiService.get(`/master/get-pg-by-block/${blockId}`);
      setPgsByBlock((prev) => ({
        ...prev,
        [blockId]: response.data.body || []
      }));
    } catch (error) {
      console.error(`Error fetching PGs for block ${blockId}:`, error);
    }
  };

  // trigger when district changes
  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  // trigger when selected blocks change
  useEffect(() => {
    if (selectedBlocks.length > 0) {
      selectedBlocks.forEach((blkId) => {
        // fetch PGs only if not already loaded
        if (!pgsByBlock[blkId]) {
          fetchPgsByBlock(blkId);
        }
      });
    }
  }, [selectedBlocks]);

  const fetchGenders = async () => {
    try {
      const response = await apiService.get(`/master/get-all-gender`);
      setGenders(response.data);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  }
 
  // const fetchUserDetails = async () => {
  //   try {
  //     const response = await apiService.get(`/users/get/${userId}`);
  //     const userData = response.data.body;

  //     // ✅ Basic fields
  //     setUsername(userData.userName || "");
  //     setEmail(userData.email || "");
  //     setPHone(userData.phoneNumber || "");
  //     setAge(userData.age || 0);
  //     setGendId(userData.genderId || 0);
  //     setUserRoleId(userData.userRoleId || 0);
  //     setRoleName(userData.userRole || "");  // ✅ roleName for conditional rendering
  //     setAadhaarNumber(userData.aadhaarNumber || "");
  //     setDistrictId(userData.districtId || 0);
  //     setDistrict(userData.districtName || "");


  //     setDist(userData.districtId || 0);

  //     // ✅ Block pre-fill
  //     if (userData.blockId) {
  //       setSelectedBlocks([userData.blockId]);
  //     }

  //     // ✅ PGs pre-fill
  //     if (userData.producerGroups && userData.producerGroups.length > 0) {
  //       const pgIds = userData.producerGroups.map(pg => pg.producerGroupId);
  //       setSelectedPgs(pgIds);

  //       // Store in block -> PG mapping so checkboxes can work properly
  //       setPgsByBlock((prev) => ({
  //         ...prev,
  //         [userData.blockId]: userData.producerGroups.map(pg => ({
  //           producerGroupId: pg.producerGroupId,
  //           pgName: pg.producerGroupName,
  //           pgCode: "" // no pgCode in API, keep blank or fetch separately
  //         }))
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user details:", error);
  //   }
  // };

// 1
// const fetchUserDetails = async () => {
//   try {
//     const response = await apiService.get(`/users/get/${userId}`);
//     const userData = response.data.body;

//     // ✅ Basic user info
//     setUsername(userData.userName || "");
//     setEmail(userData.email || "");
//     setPHone(userData.phoneNumber || "");
//     setAge(userData.age || 0);
//     setGendId(userData.genderId || 0);
//     setUserRoleId(userData.userRoleId || 0);
//     setRoleName(userData.userRole || "");
//     setAadhaarNumber(userData.aadhaarNumber || "");
//     setDistrict(userData.districtNames?.[0] || "");
//     setDistrictId(userData.districtIds?.[0] || 0);
//     setDist(userData.districtIds?.[0] || 0);

//     // ✅ Handle blocks and producer groups
//     if (userData.blocks && userData.blocks.length > 0) {
//       // Store all block IDs
//       const blockIds = userData.blocks.map(block => block.blockId);
//       setSelectedBlocks(blockIds);

//       // Flatten all PGs across all blocks
//       const allPgIds = userData.blocks.flatMap(block =>
//         block.producerGroups.map(pg => pg.producerGroupId)
//       );
//       setSelectedPgs(allPgIds);

//       // Map blockId -> PG details for checkbox rendering
//       const pgMapping = {};
//       userData.blocks.forEach(block => {
//         pgMapping[block.blockId] = block.producerGroups.map(pg => ({
//           producerGroupId: pg.producerGroupId,
//           pgName: pg.producerGroupName,
//           pgCode: "" // optional, since not in API
//         }));
//       });

//       setPgsByBlock(pgMapping);
//     } else {
//       // fallback if no blocks
//       setSelectedBlocks([]);
//       setSelectedPgs([]);
//       setPgsByBlock({});
//     }

//   } catch (error) {
//     console.error("Error fetching user details:", error);
//   }
// };


// 3
// const fetchUserDetails = async () => {
//   try {
//     // 1️⃣ Fetch user details
//     const response = await apiService.get(`/users/get/${userId}`);
//     const userData = response.data.body;

//     // ✅ Basic user info
//     setUsername(userData.userName || "");
//     setEmail(userData.email || "");
//     setPHone(userData.phoneNumber || "");
//     setAge(userData.age || 0);
//     setGendId(userData.genderId || 0);
//     setUserRoleId(userData.userRoleId || 0);
//     setRoleName(userData.userRole || "");
//     setAadhaarNumber(userData.aadhaarNumber || "");
//     setDistrict(userData.districtNames?.[0] || "");
//     setDistrictId(userData.districtIds?.[0] || 0);
//     setDist(userData.districtIds?.[0] || 0);

//     // 2️⃣ Handle blocks and pre-fill PGs
//     if (userData.blocks && userData.blocks.length > 0) {
//       // All block IDs assigned to user
//       const blockIds = userData.blocks.map(block => block.blockId);
//       setSelectedBlocks(blockIds);

//       // PGs already assigned to user
//       const assignedPgIds = userData.blocks.flatMap(block =>
//         block.producerGroups.map(pg => pg.producerGroupId)
//       );
//       setSelectedPgs(assignedPgIds);

//       // 3️⃣ For each block, fetch all PGs from the master API
//       const pgMapping = {};

//       for (const block of userData.blocks) {
//         try {
//           const pgResponse = await apiService.get(`/master/get-pg-by-block/${block.blockId}`);
//           const pgList = pgResponse.data.body || [];

//           // Prepare PG objects
//           const formattedPGs = pgList.map(pg => ({
//             producerGroupId: pg.producerGroupId,
//             pgName: pg.pgName,
//             pgCode: pg.pgCode
//           }));

//           pgMapping[block.blockId] = formattedPGs;
//         } catch (err) {
//           console.error(`Error fetching PGs for block ${block.blockId}:`, err);
//           pgMapping[block.blockId] = []; // fallback empty list
//         }
//       }

//       // 4️⃣ Save the block→PG mapping
//       setPgsByBlock(pgMapping);
//     } else {
//       // fallback if no blocks
//       setSelectedBlocks([]);
//       setSelectedPgs([]);
//       setPgsByBlock({});
//     }
//   } catch (error) {
//     console.error("Error fetching user details:", error);
//   }
// };

const fetchUserDetails = async () => {
  try {
    // 1️⃣ Fetch user details
    const response = await apiService.get(`/users/get/${userId}`);
    const userData = response.data.body;

    if (!userData) return;

    // ✅ Basic user info
    setUsername(userData.userName || "");
    setEmail(userData.email || "");
    setPHone(userData.phoneNumber || "");
    setAge(userData.age || 0);
    setGendId(userData.genderId || 0);
    setUserRoleId(userData.userRoleId || 0);
    setRoleName(userData.userRole || "");
    setAadhaarNumber(userData.aadhaarNumber || "");

    // ✅ Handle district data (supports both array & single)
  if (userData.districtIds || userData.districtNames) {
  const distId = userData.districtIds?.[0] || 0;
  setDistrictId(distId);
  setDist(distId); // must set the numeric ID
  setDistrict(userData.districtNames?.[0] || "");
} else {
  const distId = userData.districtId || 0;
  setDistrictId(distId);
  setDist(distId); // must set the numeric ID
  setDistrict(userData.districtName || "");
}


    // 2️⃣ Handle blocks and PGs (if available)
    if (Array.isArray(userData.blocks) && userData.blocks.length > 0) {
      const blockIds = userData.blocks.map(block => block.blockId);
      setSelectedBlocks(blockIds);

      // Already assigned PGs
      const assignedPgIds = userData.blocks.flatMap(block =>
        (block.producerGroups || []).map(pg => pg.producerGroupId)
      );
      setSelectedPgs(assignedPgIds);

      // 3️⃣ Fetch all PGs for each block
      const pgMapping = {};
      for (const block of userData.blocks) {
        try {
          const pgResponse = await apiService.get(`/master/get-pg-by-block/${block.blockId}`);
          const pgList = pgResponse.data.body || [];

          const formattedPGs = pgList.map(pg => ({
            producerGroupId: pg.producerGroupId,
            pgName: pg.pgName,
            pgCode: pg.pgCode
          }));

          pgMapping[block.blockId] = formattedPGs;
        } catch (err) {
          console.error(`Error fetching PGs for block ${block.blockId}:`, err);
          pgMapping[block.blockId] = [];
        }
      }

      setPgsByBlock(pgMapping);
    } else {
      // 4️⃣ Fallback when no blocks exist
      setSelectedBlocks([]);
      setSelectedPgs([]);
      setPgsByBlock({});
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};



  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };



  const handleCheckboxChange = (pgId) => {
    setSelectedPgs((prevSelected) =>
      prevSelected.includes(pgId)
        ? prevSelected.filter((id) => id !== pgId)
        : [...prevSelected, pgId]
    );
  };
  const handleBlockChange = (blockId) => {
    setSelectedBlocks((prev) =>
      prev.includes(blockId)
        ? prev.filter((id) => id !== blockId)
        : [...prev, blockId]
    );
  };





  // const handleUpdate = async () => {
  //   const updatedUser = {
  //     userName: username,
  //     email: email,
  //     phoneNumber: phone,
  //     genderId: gendid,
  //     userRoleId: userRoleId,
  //     age: age,
  //     aadhaarNumber: aadhaarNumber,
  //     districtId: dist,   // ✅ use dist from dropdown
  //     confirmPassword: confirmPassword,
  //     password: password
  //   };

  //   try {
  //     await apiService.put(`/users/update/${userId}`, updatedUser);
  //     alert("User updated successfully");
  //     navigate(-1);
  //   } catch (error) {
  //     console.error("Error updating user:", error);
  //     alert("Failed to update user");
  //   }
  // };


  // const handleUpdate = async () => {
  //   const trimmedUserName = (username ?? "").trim();
  //   const trimmedEmail = (email ?? "").trim();
  //   const trimmedPhone = (phone ?? "").trim();
  //   const trimmedPassword = (password ?? "").trim();

  //   if (
  //     !trimmedUserName ||
  //     !trimmedEmail ||
  //     !trimmedPhone ||
  //     !trimmedPassword ||
  //     gendid === 0 ||
  //     userRoleId === 0 ||
  //     age <= 0
  //   ) {
  //     alert("All fields are required and must be valid.");
  //     return;
  //   }

  //   const userPayload = {
  //     userName: trimmedUserName,
  //     email: trimmedEmail,
  //     phoneNumber: trimmedPhone,
  //     password: trimmedPassword,
  //     genderId: gendid,
  //     userRoleId: userRoleId,
  //     age: age,
  //     districtId: dist,
  //     aadhaarNumber: aadhaarNumber,
  //     blocksWithPgs: selectedBlocks.map((blk) => ({
  //       blockId: blk,
  //       producerGroupIds: setPgsByBlock[blk] || []
  //     }))
  //   };

  //   try {
  //     const response = await apiService.put(`/users/update/${userId}`, userPayload);
  //     if (response.data.status === true) {
  //       alert("User created successfully!");
  //       navigate(-1);
  //     } else {
  //       alert("Failed to create user. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error creating user:", error);
  //     alert("An error occurred while updating the user.");
  //   }
  // };


//   const handleUpdate = async () => {
//   const trimmedUserName = (username ?? "").trim();
//   const trimmedEmail = (email ?? "").trim();
//   const trimmedPhone = (phone ?? "").trim();
//   const trimmedPassword = (password ?? "").trim();

//   // ✅ Validation
//   if (
//     !trimmedUserName ||
//     !trimmedEmail ||
//     !trimmedPhone ||
//     !trimmedPassword ||
//     gendid === 0 ||
//     userRoleId === 0 ||
//     age <= 0
//   ) {
//     alert("All fields are required and must be valid.");
//     return;
//   }

//   // ✅ Extract Block & PG IDs
//   const blockIds = selectedBlocks || [];
//   const producerGroupIds = selectedPgs || [];

//   // ✅ Base payload
//   const userPayload = {
//     userName: trimmedUserName,
//     email: trimmedEmail,
//     phoneNumber: trimmedPhone,
//     password: trimmedPassword,
//     genderId: gendid,
//     userRoleId: userRoleId,
//     age: age,
//     districtId: dist,
//     aadhaarNumber: aadhaarNumber,
//     blockIds: blockIds,
//   };

//   // ✅ Add producerGroupIds only if available
//   if (producerGroupIds.length > 0) {
//     userPayload.producerGroupIds = producerGroupIds;
//   }

//   try {
//     const response = await apiService.put(`/users/update/${userId}`, userPayload);
//     if (response.data.status === true) {
//       alert("User updated successfully!");
//       navigate(-1);
//     } else {
//       alert("Failed to update user. Please try again.");
//     }
//   } catch (error) {
//     console.error("Error updating user:", error);
//     alert("An error occurred while updating the user.");
//   }
// };

const handleUpdate = async () => {
  const trimmedUserName = (username ?? "").trim();
  const trimmedEmail = (email ?? "").trim();
  const trimmedPhone = (phone ?? "").trim();
  const trimmedPassword = (password ?? "").trim();

  // ✅ Validation
  if (
    !trimmedUserName ||
    !trimmedEmail ||
    !trimmedPhone ||
    !trimmedPassword ||
    gendid === 0 ||
    userRoleId === 0 ||
    age <= 0 ||
    dist === 0
  ) {
    alert("All fields are required and must be valid.");
    return;
  }

  // ✅ Extract Block & PG IDs
  const blockIds = selectedBlocks || [];
  const producerGroupIds = selectedPgs || [];

  // ✅ Build user payload
  const userPayload = {
    userName: trimmedUserName,
    email: trimmedEmail,
    phoneNumber: trimmedPhone,
    password: trimmedPassword,
    genderId: gendid,
    userRoleId: userRoleId,
    age: age,
    districtId: dist,
    aadhaarNumber: aadhaarNumber,
    blockIds: blockIds,
  };

  if (producerGroupIds.length > 0) {
    userPayload.producerGroupIds = producerGroupIds;
  }

  try {
    // ✅ 1️⃣ Update user profile
    const response = await apiService.put(`/users/update/${userId}`, userPayload);

    if (response.data.status === true) {
      // ✅ 2️⃣ Get logged-in user info from localStorage
      const loginData = JSON.parse(localStorage.getItem("loginData"));
      const updatedById = loginData?.userId;

      if (!updatedById) {
        console.error("UpdatedById not found in localStorage");
        alert("Session invalid. Please log in again.");
        return;
      }

      // ✅ 3️⃣ Prepare password payload
      const passwordPayload = {
        password: trimmedPassword,
      };

      // ✅ 4️⃣ Call update-password API
      const passResponse = await apiService.put(
        `/users/update-password/${userId}?updatedById=${updatedById}`,
        passwordPayload
      );

      if (passResponse.data.status === true) {
        alert("User and password updated successfully!");
        navigate(-1);
      } else {
        alert("User and password updated successfully!");
                navigate(-1);

      }
    } else {
      alert("Failed to update user. Please try again.");
    }
  } catch (error) {
    console.error("Error updating user:", error);
    alert("An error occurred while updating the user.");
  }
};



  useEffect(() => {
    fetchRoleId();
    if (userId !== null) {
      fetchUserDetails();
    }
  }, [userId]);

  useEffect(() => {
    fetchGenders();
    fetchAllDist();

  }, []);
  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowX: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Header title="Edit User" />
          <div className="d-flex">
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                padding: "10px 16px",
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                marginRight: "10px",
                border: "1px solid #1976d2",
                color: "#1976d2",
                "&:hover": {
                  background: "#e3f2fd",
                },
              }}
              onClick={handleBack}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="primary"
              sx={{
                padding: "10px 16px",
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                "&:hover": {
                  background: "linear-gradient(90deg, #1565c0, #2196f3)",
                },
              }}
              onClick={handleUpdate}
            >
              Save
            </Button>
          </div>
        </div>
        <Card className="mx-5 mb-2">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{ fontWeight: "bold" }}>Enter Details</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
            <Row>

              <Col md={6} className="mb-3">
                <Form.Group controlId="username">
                  <Form.Label style={{ fontWeight: "bold" }}>User Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter user name" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                </Form.Group>
              </Col>


              <Col md={6} className="mb-3">
                <Form.Group controlId="email">
                  <Form.Label style={{ fontWeight: "bold" }}>Email</Form.Label>
                  <Form.Control type="text" placeholder="Enter email" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="phone">
                  <Form.Label style={{ fontWeight: "bold" }}>Phone Number</Form.Label>
                  <Form.Control type="text" placeholder="Enter phone number" value={phone} onChange={(e) => { setPHone(e.target.value) }} />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="aadhaarNumber">
                  <Form.Label style={{ fontWeight: "bold" }}>Aadhaar Number</Form.Label>
                  <Form.Control type="text" placeholder="Enter Aadhaar number" value={aadhaarNumber} onChange={(e) => { setAadhaarNumber(e.target.value) }} />
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group controlId="password">
                  <Form.Label style={{ fontWeight: "bold" }}> password</Form.Label>
                  <Form.Control type="text" placeholder="Enter Password" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="confirmPassword">
                  <Form.Label style={{ fontWeight: "bold" }}>Confirm password</Form.Label>
                  <Form.Control type="text" placeholder="Enter Confirm password" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} />
                </Form.Group>
              </Col>



              <Col md={6} className="mb-3">
                <Form.Group controlId="description">
                  <Form.Label style={{ fontWeight: "bold" }}>Age</Form.Label>
                  <Form.Control type="text" placeholder="Enter Age" value={age} onChange={(e) => { setAge(Number(e.target.value)) }} />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="description">
                  <Form.Label style={{ fontWeight: "bold" }}>Gender</Form.Label>
                  <Form.Control
                    as="select"
                    value={gendid}
                    onChange={(e) => { setGendId(Number(e.target.value)); }}
                    className="form-select form-select-md"
                  >
                    <option value={0} disabled >Select</option>
                    {genders.map((gen) => (
                      <option key={gen.genderId} value={gen.genderId}>
                        {gen.gender}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>


              {/* <Col md={6} className="mb-3">
          <Form.Group controlId="roleName">
            <Form.Label style={{fontWeight:"bold"}}>Select User Role</Form.Label>
            <Form.Control
            as="select"
            value={userRoleId}
            onChange={(e)=>{setUserRoleId(Number(e.target.value))}}
            className="form-select form-select-md"
            >
          <option value="" disabled>
            Select Role
          </option>
          {roles.map((role) => (
            <option key={role.userRoleId} value={role.userRoleId}>
              {role.roleName}
            </option>
          ))}
        </Form.Control>        
        </Form.Group>
        </Col> */}
            </Row>
          </Form>
        </Card>

        {/* // for role edit card */}

        <Card className="mx-5 mb-2">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{ fontWeight: "bold" }}>Enter Role Details</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
            <Row>
              <Col xs={12} md={6}>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="roleName">
                    <Form.Label style={{ fontWeight: "bold" }}>Select User Role</Form.Label>
                    <Form.Control
                      as="select"
                      value={userRoleId}
                      onChange={(e) => {
                        const selectedRoleId = Number(e.target.value);
                        setUserRoleId(selectedRoleId);
                        const selectedRole = roles.find((role) => role.userRoleId === selectedRoleId);
                        setRoleName(selectedRole?.roleName || "");
                        setDist(0);
                        setBlock(0);
                        setPgs([]);
                        setSelectedPgs([]);
                        setPgsByBlock({});
                        setSelectedBlocks([]);
                      }}
                      className="form-select form-select-md"
                    >
                      <option value={0} disabled>
                        Select Role
                      </option>
                      {roles.map((role) => (
                        <option key={role.userRoleId} value={role.userRoleId}>
                          {role.roleName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Col>
              <Col xs={12} md={6}>

                <Col md={12} className="mb-3">
                  <Form.Group controlId="dist">
                    <Form.Label style={{ fontWeight: "bold" }}>Select Dist</Form.Label>
                    <Form.Control
                      as="select"
                      value={dist}   // <-- this must hold the districtId from userData
                      onChange={(e) => {
                        setDist(Number(e.target.value));
                        setBlock(0);
                        setPgs([]);
                        setSelectedPgs([]);
                      }}
                      className="form-select form-select-md"
                    >
                      <option value={0} disabled>
                        Select Dist
                      </option>
                      {dists.map((dst) => (
                        <option key={dst.districtId} value={dst.districtId}>
                          {dst.districtName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                </Col>
                {(rolename === "Block Coordinator" || rolename === "Producer Group Facilitator") && dist > 0 && (
                  <Col md={12} className="mb-3">
                    <Form.Group controlId="block">
                      <Form.Label style={{ fontWeight: "bold" }}>Select Blocks</Form.Label>
                      <div className="p-2 border rounded" style={{ maxHeight: "200px", overflowY: "scroll" }}>
                        {blocks.map((blk) => (
                          <Form.Check
                            key={blk.blockId}
                            type="checkbox"
                            id={`block-checkbox-${blk.blockId}`}
                            label={blk.blockName}
                            value={blk.blockId}
                            checked={selectedBlocks.includes(blk.blockId)}
                            onChange={() => handleBlockChange(blk.blockId)}
                            className="mb-2"
                          />
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                )}

                {rolename === "Producer Group Facilitator" && selectedBlocks.length > 0 && (
                  <Col md={12} className="mb-3">
                    <Form.Group controlId="pgs">
                      <Form.Label style={{ fontWeight: "bold" }}>Select PGs</Form.Label>
                      <div className="p-2 border rounded" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                        {selectedBlocks.map((blkId) => {
                          const blk = blocks.find((b) => b.blockId === blkId);
                          return (
                            <div key={blkId} className="mb-3">
                              <h6 style={{ fontWeight: "bold", color: "#1976d2" }}>{blk?.blockName}</h6>
                              {pgsByBlock[blkId]?.map((pg) => (
                                <Form.Check
                                  key={pg.producerGroupId}
                                  type="checkbox"
                                  id={`pg-checkbox-${pg.producerGroupId}`}
                                  label={`${pg.pgName} - ${pg.pgCode}`}
                                  value={pg.producerGroupId}
                                  checked={selectedPgs.includes(pg.producerGroupId)}
                                  onChange={() => handleCheckboxChange(pg.producerGroupId)}
                                  className="ms-3 mb-2"
                                />
                              ))}
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Col>
            </Row>
          </Form>
        </Card>

      </div>
    </Box>
  )
}

export default EditUser